// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","TextLiveStatus":"bK2dZy","isStandalone":"_3TxJxR","fadeInFrames":"_3LDRRp"};